module.exports = __webpack_public_path__ + "img/why-championla_image4.69310561.jpg";